// Generated by CoffeeScript 1.12.7
(function () {
  var FeatureFlag, ViewDetailVisualization;

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  module.exports = ViewDetailVisualization = (function () {
    function ViewDetailVisualization(
      di,
      createUi,
      usingFeature,
      make,
      modalAngular,
      view,
      account,
      projectId,
      PageEventData,
    ) {
      var _projectId, eventData;
      _projectId = null;
      if (projectId != null && projectId !== "") {
        _projectId = projectId;
      }
      eventData = make(PageEventData, {
        view: view,
        scope: {
          viewId: view.pageViewId,
          projectId: _projectId,
        },
      });
      di.value("eventData", eventData);
      this.ui = createUi(require("Analytics/Visualizations/Views/Detail/Detail.html"), {
        view: view,
        blocks: make(require("../../Blocks/Blocks"), {
          options: {
            averages: false,
            groupViews: false,
          },
        }),
        links: make(require("../../Links/Links")),
        showIdentityLine: function () {
          return account.plan.features.indexOf("security") >= 0;
        },
      });
      this.show = (function (_this) {
        return function () {
          return modalAngular.show(_this.ui, {
            customClass: "analytics-detail-modal",
          });
        };
      })(this);
    }

    return ViewDetailVisualization;
  })();
}.call(this));
